// extracted by mini-css-extract-plugin
export default {"wrap":"StatisticsPage_wrap__dBcnp","menuBlock":"StatisticsPage_menuBlock__ws7sJ","outletBlock":"StatisticsPage_outletBlock__Ij3QS"};